module.exports = __webpack_public_path__ + "img/04.1a6252e3.jpg";